import { storyblokEditable } from "@storyblok/react";
const SingleImageBig = ({ blok }) => {
  return (

    <div className="wrap">
    <div className="inner-wrap">

         {blok.headline && (
             <h2 className="singleimage-subheadline merriweather text-xl pb-6">
             {blok.headline}
             </h2>
          )}

      <div className="singleimage-wrap" {...storyblokEditable(blok)}>
          
        <img src={blok.image.filename} alt={blok.image.alt} />
      </div>


        {blok.headline && (
            <h2 className="singleimage-borderbottom merriweather text-xl pb-6"></h2>
        )}

    </div>
    </div>
  
  );
};
export default SingleImageBig;




